import { ReactNode, useCallback } from 'react';

import { useTranslation } from 'react-i18next';

import { TABS } from '../../Interactions/constants';
import { InteractionBadges } from '../../hooks/useInteractionBadges';
import * as S from './styles';

type Tab = typeof TABS[number];

type MobileDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
  activeTab: string;
  onTabChange: (tabId: string) => void;
  visibleTabs: Tab[];
  badges?: InteractionBadges;
  children: ReactNode;
};

const MobileDrawer = ({
  isOpen,
  onClose,
  activeTab,
  onTabChange,
  visibleTabs,
  badges,
  children,
}: MobileDrawerProps) => {
  const { t } = useTranslation();

  const handleOverlayClick = useCallback(() => {
    onClose();
  }, [onClose]);

  const handleTabClick = useCallback(
    (tabId: string) => {
      onTabChange(tabId);
    },
    [onTabChange],
  );

  if (!isOpen) return null;

  return (
    <>
      <S.Overlay onClick={handleOverlayClick} />
      <S.DrawerContainer>
        <S.HandleBar onClick={onClose} />
        <S.DrawerContent>
          <S.TabsWrapper>
            {visibleTabs.map((tab) => {
              const badgeValue = badges?.[tab.id as keyof InteractionBadges];
              return (
                <S.TabButton
                  key={tab.id}
                  $active={activeTab === tab.id}
                  onClick={() => handleTabClick(tab.id)}
                >
                  <tab.icon size="1rem" />
                  <span>{t(tab.title)}</span>
                  {badgeValue && <S.Badge>{badgeValue}</S.Badge>}
                </S.TabButton>
              );
            })}
          </S.TabsWrapper>
          <S.ContentWrapper>{children}</S.ContentWrapper>
        </S.DrawerContent>
      </S.DrawerContainer>
    </>
  );
};

export default MobileDrawer;
